import { render, staticRenderFns } from "./TennisMatches.vue?vue&type=template&id=249d3dd4&"
import script from "./TennisMatches.vue?vue&type=script&lang=js&"
export * from "./TennisMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports